import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Heading } from 'components/Ui-Kits/Text'
import { any, bool, func, string } from 'prop-types'
import styled from 'styled-components'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { createPortal } from 'react-dom'
export const Modal = ({ title, onClose, children, show }) => {
  return (
    show &&
    createPortal(
      <MmodalWrap>
        <ContentWrap>
          <Content>
            {(title || onClose) && (
              <TitleWrap>
                <Heading mt={0} mb={0}>
                  {title}
                </Heading>
                {onClose && <Icon icon={faTimes} onClick={onClose} />}
              </TitleWrap>
            )}
            <ChildrenWrap>{children}</ChildrenWrap>
          </Content>
        </ContentWrap>
      </MmodalWrap>,
      document.body
    )
  )
}

Modal.propTypes = {
  show: bool,
  onClose: func,
  title: string,
  children: any,
}

const MmodalWrap = styled.div`
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  left: 0;
  top: 0;
  flex-direction: row;
  overflow: auto;
  z-index: 1000;
`

const ContentWrap = styled.div`
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: 2rem;
  overflow: auto;
`
const Content = styled.div`
  width: 700px;
  max-width: 100%;
  background-color: var(--color-white);
`
const TitleWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
`

const ChildrenWrap = styled.div`
  padding: 1rem;
`

const Icon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  cursor: pointer;
  color: var(--color-primary);
`
